export default "/images/man.png?74e801cb90ad41a6d112f699429591b5";